import AiServicedList from 'modules/analytics/components/AiServicedList/AiServicedList';
import BimServicedList from 'modules/analytics/components/BimServicedList/BimServicedList';
import useAiActivityListData from 'modules/analytics/hooks/useAiActivityListData';
import useBimActivityListData from 'modules/analytics/hooks/useBimActivityListData';
import { PageHeading, PageTemplate } from 'modules/shared/features/content';

const AiServicedPage = () => {
    const { data: logs, isLoading } = useAiActivityListData();

    return (
        <PageTemplate>
            <PageHeading className="flex justify-between items-center">
                <div>AI Activation</div>
            </PageHeading>

            <div>
                <AiServicedList isLoading={isLoading} cameras={logs} />
            </div>
        </PageTemplate>
    );
};

export default AiServicedPage;
